"use strict";
/*!
 *
 * utility.ts
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
// Break point setting.
var breakPoint = [768, 992, 1220];
var gap = {
    element: document.getElementById('Widget'),
    spelement: document.getElementById('Widget'),
    viewport: {
        phone: true,
        tablet: true,
        desktop: true,
        largeDesktop: true
    }
};
var util = {
    ww: window.innerWidth,
    wh: window.innerHeight,
    hash: location.hash,
    viewport: 'desktop',
    scroller: 'html,body',
    scrollGap: 10
};
util.viewport = (function () {
    if (util.ww < breakPoint[0]) {
        return 'phone';
    }
    else if (util.ww >= breakPoint[0] && util.ww < breakPoint[1]) {
        return 'tablet';
    }
    else if (util.ww >= breakPoint[1] && util.ww < breakPoint[2]) {
        return 'desktop';
    }
    else if (util.ww >= breakPoint[2]) {
        return 'largeDesktop';
    }
    ;
})();
function setScrollGap() {
    if (gap.viewport[util.viewport]) {
        if (gap.element !== null) {
            var local = document.getElementById('Local');
            if (util.viewport !== 'phone') {
                if (local) {
                    return gap.element.offsetHeight + local.offsetHeight + 32;
                }
                else {
                    return gap.element.offsetHeight + 32;
                }
                ;
            }
            else {
                if (local) {
                    return gap.spelement.offsetHeight + local.offsetHeight + 16;
                }
                else {
                    return gap.spelement.offsetHeight + 16;
                }
                ;
            }
        }
        else {
            return 30;
        }
        ;
    }
    else {
        return 20;
    }
    ;
}
;
util.scrollGap = setScrollGap();
var html = document.documentElement;
var body = document.querySelector('body');
function getScrollbarWidth() {
    var element = document.createElement('div');
    element.style.visibility = 'hidden';
    element.style.overflow = 'scroll';
    if (body) {
        body.appendChild(element);
        var scrollbarWidth = element.offsetWidth - element.clientWidth;
        body.removeChild(element);
        return scrollbarWidth;
    }
    else {
        return 0;
    }
}
var setSize = function () {
    var vh = window.innerHeight * 0.01;
    html.style.setProperty('--vh', vh + "px");
    if (getScrollbarWidth() > 0) {
        var scrollbar = getScrollbarWidth();
        html.style.setProperty('--scroll-bar', scrollbar + "px");
    }
    ;
};
setSize();
var check_webp_1 = require("check-webp");
check_webp_1.checkWebP(function (support) {
    if (!support) {
        html.classList.add('not-work-webp');
    }
    ;
});
var custom_event_1 = __importDefault(require("custom-event"));
var viewportChanged = new custom_event_1.default('viewportChanged');
window.addEventListener('resize', function () {
    util.wh = window.innerHeight;
    util.ww = window.innerWidth;
    if (util.viewport !== 'phone' && util.ww < breakPoint[0]) {
        util.viewport = 'phone';
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'tablet' && util.ww >= breakPoint[0] && util.ww < breakPoint[1]) {
        util.viewport = 'tablet';
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'desktop' && util.ww >= breakPoint[1] && util.ww < breakPoint[2]) {
        util.viewport = 'desktop';
        window.dispatchEvent(viewportChanged);
    }
    ;
    if (util.viewport !== 'largeDesktop' && util.ww >= breakPoint[2]) {
        util.viewport = 'largeDesktop';
        window.dispatchEvent(viewportChanged);
    }
    ;
    util.scrollGap = setScrollGap();
    setSize();
}, { passive: true });
window.addEventListener('load', function () {
    util.scrollGap = setScrollGap();
}, { passive: true });
module.exports = util;
